import "../styles/css/request-estimate.css"
import {useState} from "react";
const EstimateRequestThanksPage: React.FC = () => {
    const [activeProperty, setActiveProperty] = useState<string>('Residential')
    return (
        <div className='request-body'>
            <div className="container estimate-container">
                <div className="page-card estimate-thanks">
                    <i className="fas fa-thumbs-up thanks-icon"></i>
                    <h1>Thanks!</h1>
                    <p>Lorem ipsum your request for an estimate has been sent. Lorem ipsum hear from us within 3 days. Lorem
                        ipsum call or email us if you need stuff.</p>
                    <p>(123) 123-1234<br/><a href="mailto:email@barreca.com">email@barreca.com</a></p>
                </div>
            </div>
        </div>
    )
}
export default EstimateRequestThanksPage;